import { Component, computed, inject, OnInit, ViewContainerRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpinnerComponent } from '@arpes-is/angular-20-spinner';
import { ToastModule } from 'primeng/toast';

import { ThemeStoreService } from '../shared/themes/theme-store.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly viewContainer = inject(ViewContainerRef);
  // Iniettato subito: applica il tema salvato (cookie condiviso con il QdC), anche sulle pagine di login.
  private readonly themeStore = inject(ThemeStoreService);

  /** Logo della famiglia in basso a destra, come nel QdC: chiaro sui temi scuri, scuro sul tema chiaro. */
  readonly novatellusLogo = computed(() =>
    this.themeStore.theme() === 'light'
      ? 'assets/images/Novatellus_Dark.svg'
      : 'assets/images/Novatellus_Light.svg',
  );

  ngOnInit(): void {
    // SpinnerComponent è dichiarato in un NgModule: importare il modulo qui creerebbe un secondo
    // SharedSpinnerService. Creato così usa quello dell'injector radice, lo stesso dei facade.
    this.viewContainer.createComponent(SpinnerComponent);
  }
}
